import FilterOptionList from "../../reservation_v2/filters/FilterOptionList";
import FilterPopover from "../../reservation_v2/filters/FilterPopover";
import {
  FilterOption,
  RESERVATION_PAYMENT_METHOD_OPTIONS,
  summarise
} from "../../reservation_v2/filters/reservationFilters";
import useFilterParams from "../../reservation_v2/filters/useFilterParams";
import {
  ESIM_BUS_OPTIONS,
  ESIM_CHANNEL_GROUPS,
  ESIM_FILTER_KEYS as KEYS,
  ESIM_PROFILE_STATUS_OPTIONS,
  ESIM_TYPE_OPTIONS
} from "./esimReservationFilters";

const labelOf = (options: FilterOption[], value: string) =>
  options.find((o) => o.value === value)?.label || "";

// A chip with one choice out of a short list; picking the chosen one again clears it.
const SingleChoice = ({ label, paramKey, options, width = "w-56" }: {
  label: string; paramKey: string; options: FilterOption[]; width?: string;
}) => {
  const { get, set } = useFilterParams();
  const value = get(paramKey);

  return (
    <FilterPopover
      label={label}
      value={labelOf(options, value)}
      onClear={() => set({ [paramKey]: "" })}
      panelClassName={width}
    >
      {(close) => (
        <FilterOptionList
          options={options}
          selected={[value]}
          onToggle={(next) => {
            set({ [paramKey]: next === value ? "" : next });
            close();
          }}
        />
      )}
    </FilterPopover>
  );
};

// Payment (Stripe and NLB, as on the ticket list), channel, type, eSIM status and bus ticket.
const FilterEsimSelects = () => {
  const { get, set } = useFilterParams();
  const channels = get(KEYS.channels).split(",").filter(Boolean);
  const chosenChannels = ESIM_CHANNEL_GROUPS.filter((group) => channels.includes(group.value));

  return (
    <>
      <SingleChoice
        label="Pagesa"
        paramKey={KEYS.paymentMethodId}
        options={RESERVATION_PAYMENT_METHOD_OPTIONS}
      />
      <FilterPopover
        label="Kanali"
        value={summarise(chosenChannels.map((group) => group.label))}
        onClear={() => set({ [KEYS.channels]: "" })}
        panelClassName="w-64"
      >
        {() => (
          <>
            <FilterOptionList
              multiple
              options={ESIM_CHANNEL_GROUPS}
              selected={channels}
              onToggle={(value) => set({
                [KEYS.channels]: (channels.includes(value)
                  ? channels.filter((v) => v !== value)
                  : [...channels, value]).join(",")
              })}
            />
            <p className="mt-2 text-xs text-neutral">Shfaqen rezervimet nga cilido kanal i zgjedhur.</p>
          </>
        )}
      </FilterPopover>
      <SingleChoice label="Lloji" paramKey={KEYS.type} options={ESIM_TYPE_OPTIONS} width="w-48" />
      <SingleChoice
        label="Statusi i eSIM-it"
        paramKey={KEYS.esimStatus}
        options={ESIM_PROFILE_STATUS_OPTIONS}
      />
      <SingleChoice label="Bileta" paramKey={KEYS.bus} options={ESIM_BUS_OPTIONS} />
    </>
  );
};

export default FilterEsimSelects;
